export default __webpack_public_path__ + "static/skull_b.b8f2241db0043ad94ef54bf73b2d0bbe.svg";